export default __webpack_public_path__ + "static/media/hht1_ep16_minisitcom_04.f02a2522.png";